import { REDUCE_POLICY_ADJUSTMENTS } from '../../constants/actions/policy';

export function reducePolicyAdjustments(payload) {
    return {
        type: REDUCE_POLICY_ADJUSTMENTS,
        payload,
    };
}
